<template lang="pug">

td
  .row-lessons
    .lesson(v-for="lesson, i in lessonsList" :key="i")
      template(v-if="lesson")
        div
          a.subject-link(v-if="lesson.subject.infoUrl" :href="lesson.subject.infoUrl" target="_blank") {{ lesson.subject.name }}
          span(v-else) {{ lesson.subject.name }}

          template(v-if="lesson.typeLesson")
            span.type-lesson ({{ lesson.typeLesson.name }})

        template(v-if="isCabinets")
          div {{ groupNames(lesson) }}
          div {{ getTeahcersNames(lesson) }}

        div(v-else-if="isTeachers") {{ groupNames(lesson) }}
        div(v-else) {{ getTeahcersNames(lesson) }}
        div(v-if="lesson.cabinet && !isCabinets") {{ lesson.cabinet.name }}

</template>

<script>
import { mapGetters } from 'vuex'
import { shortFio } from '@/common'

export default {
  name: 'RowLessons',

  props: {
    lessons: {
      type: Array,
      required: true,
    },
    isTeachers: {
      type: Boolean,
      default: false
    },
    isCabinets: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('bootstrap', ['fullTeacherFio']),

    lessonsList() {
      const countDivisions =
        _(this.lessons)
          .map((x) => x.unionGroups.map((u) => u.countDivisions))
          .flatten()
          .uniq()
          .find((countDivisions) => countDivisions) || 0

      if (!countDivisions) return this.lessons

      return _.range(0, countDivisions).map((order) => {
        return this.lessons.find((x) =>
          x.unionGroups.some((u) => u.subgroup?.order === order)
        )
      })
    },
  },

  methods: {
    groupNames(lesson) {
      return lesson.unionGroups
        .map((x) => x.group.name)
        .join(', ')
    },

    getTeahcersNames(lesson) {
      return lesson.teachers
        .map((x) => this.fullTeacherFio ? x.fio : shortFio(x.fio))
        .join(',')
    }
  }
}
</script>

<style lang="sass" scoped>

td
  padding: 0 !important

.row-lessons
  display: flex
  flex-direction: row
  width: 100%

.lesson
  padding: 5px
  flex: 1 1 100%

  &:not(:last-child)
    border-right: 1px solid #c1c1c1

.type-lesson
  color: #616161
  padding-left: 5px

.subject-link
  text-decoration: none

  &:hover
    text-decoration: underline

</style>
